export default __webpack_public_path__ + "static/media/PADigital.cff465cd.webp";